'use client';

import dynamic from 'next/dynamic';

import { Skeleton } from '@packages/shared/src/ui/Skeleton/Skeleton';

export const DynamicSearchField = dynamic(() => import('./SearchField'), {
  ssr: false,
  loading: () => <Skeleton className="h-[44px] w-full rounded-sm" />,
});
